// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer_footerContainer__1sd59, .footer_footerWrapper__g1S1U, .footer_sectionList__0IdVF {
    flex-direction: column;
}

.footer_sectionList__0IdVF, .footer_sectionList__0IdVF li {
    width: fit-content;
}

.footer_sectionList__0IdVF li, .footer_sectionList__0IdVF li a {
    color: #495E57;
    font-size: 16pt;
}

.footer_footerContainer__1sd59 {
    align-items: center;
    background-color: #EDEFEE;
    justify-content: space-between;
}

.footer_logoFigure__Xbhjt {
    margin-bottom: 60px;
}

.footer_footerWrapper__g1S1U {
    gap: 85px;
}

.footer_footerSection__yUoWl {
    text-align: center;
}

.footer_sectionHeading__XkP3T {
    color: #495E57;
    margin-bottom: 30px;
}

.footer_sectionList__0IdVF {
    gap: 15px;
}

.footer_sectionList__0IdVF li {
    font-family: Karla, sans-serif;
    font-weight: bold;
}

.footer_sectionList__0IdVF li:after {
    margin: unset;
}

.footer_sectionList__0IdVF li a:focus-visible {
    color: #FFF;
}

@media (min-width: 1095px) {
    .footer_footerContainer__1sd59, .footer_footerWrapper__g1S1U {
        flex-direction: row;
    }

    .footer_footerContainer__1sd59 {
        align-items: flex-start;
        gap: 80px;
        justify-content: unset;
    }

    .footer_logoFigure__Xbhjt {
        margin-bottom: 0;
    }

    .footer_footerWrapper__g1S1U {
        gap: 85px;
    }

    .footer_footerSection__yUoWl {
        text-align: left;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Footer/footer.module.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,uBAAuB;QACvB,SAAS;QACT,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".footerContainer, .footerWrapper, .sectionList {\n    flex-direction: column;\n}\n\n.sectionList, .sectionList li {\n    width: fit-content;\n}\n\n.sectionList li, .sectionList li a {\n    color: #495E57;\n    font-size: 16pt;\n}\n\n.footerContainer {\n    align-items: center;\n    background-color: #EDEFEE;\n    justify-content: space-between;\n}\n\n.logoFigure {\n    margin-bottom: 60px;\n}\n\n.footerWrapper {\n    gap: 85px;\n}\n\n.footerSection {\n    text-align: center;\n}\n\n.sectionHeading {\n    color: #495E57;\n    margin-bottom: 30px;\n}\n\n.sectionList {\n    gap: 15px;\n}\n\n.sectionList li {\n    font-family: Karla, sans-serif;\n    font-weight: bold;\n}\n\n.sectionList li:after {\n    margin: unset;\n}\n\n.sectionList li a:focus-visible {\n    color: #FFF;\n}\n\n@media (min-width: 1095px) {\n    .footerContainer, .footerWrapper {\n        flex-direction: row;\n    }\n\n    .footerContainer {\n        align-items: flex-start;\n        gap: 80px;\n        justify-content: unset;\n    }\n\n    .logoFigure {\n        margin-bottom: 0;\n    }\n\n    .footerWrapper {\n        gap: 85px;\n    }\n\n    .footerSection {\n        text-align: left;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footerContainer": `footer_footerContainer__1sd59`,
	"footerWrapper": `footer_footerWrapper__g1S1U`,
	"sectionList": `footer_sectionList__0IdVF`,
	"logoFigure": `footer_logoFigure__Xbhjt`,
	"footerSection": `footer_footerSection__yUoWl`,
	"sectionHeading": `footer_sectionHeading__XkP3T`
};
export default ___CSS_LOADER_EXPORT___;
